module.exports = __webpack_public_path__ + "media/brands/renault-526b4c51.png";